/* eslint-disable import/prefer-default-export */
import {
  MenuMessages,
  TranslationMenuMessages
} from "../interfaces";

export const messages: TranslationMenuMessages = {
  [MenuMessages.production]: "Production",
  [MenuMessages.pumps]: "Pumps",
  [MenuMessages.supportVehicles]: "Support vehicles",
  [MenuMessages.trucks]: "Trucks",
  [MenuMessages.dashboards]: "Dashboards",
  [MenuMessages.management]: "Management",
  [MenuMessages.users]: "Users",
  [MenuMessages.modules]: "Modules",
  [MenuMessages.drivers]: "Drivers",
  [MenuMessages.vehicles]: "Vehicles",
  [MenuMessages.locations]: "Locations",
  [MenuMessages.hardwares]: "Hardwares",
  [MenuMessages.SIMCards]: "SIM Cards",
  [MenuMessages.reports]: "Reports",
  [MenuMessages.scheduledReports]: "Scheduled reports",
  [MenuMessages.travelHistory]: "Travel history",
  [MenuMessages.alertHistory]: "Alert and event history",
  [MenuMessages.averageSpeed]: "Average speed",
  [MenuMessages.coordinateAnalysis]: "Coordinate analysis",
  [MenuMessages.vehicleHistory]: "Vehicle history",
  [MenuMessages.vehicleCanHistory]: "Vehicle history - CAN",
  [MenuMessages.vehicleStatesHistory]: "Vehicle states history",
  [MenuMessages.waterAdditionHistory]: "Water addition history",
  [MenuMessages.canHistory]: "CAN History",
  [MenuMessages.odometerHourmeterReport]: "Total Odometer/Hourmeter",
  [MenuMessages.others]: "Others",
  [MenuMessages.contactUs]: "Contact us",
  [MenuMessages.settings]: "Settings",
  [MenuMessages.installApp]: "Install app",
  [MenuMessages.exit]: "Exit",
  [MenuMessages.generalLocation]: "General location",
  [MenuMessages.vehiclesUnderMaintenance]: "Vehicles under maintenance",
  [MenuMessages.alerts]: "Alerts",
  [MenuMessages.speedingAlerts]: "Speeding alerts",
  [MenuMessages.canAlerts]: "CAN Alerts",
  [MenuMessages.concreteExpiration]: "Concrete expiration",
  [MenuMessages.improperDischarges]: "Improper discharges",
  [MenuMessages.vehiclesInTrustedLocations]: "Vehicles in trusted locations",
  [MenuMessages.blockedVehicles]: "Blocked vehicles",
  [MenuMessages.regionals]: "Regionals",
  [MenuMessages.help]: "Help",
  [MenuMessages.groups]: "Groups",
  [MenuMessages.pumpProgramming]: "Pump programming",
  [MenuMessages.relatedMixersDetails]: "Related Mixers Details",
  [MenuMessages.zones]: "Restriction Zones",
  [MenuMessages.driversRoles]: "Drivers Roles",
  [MenuMessages.travelAnalysis]: "Travel analysis",
  [MenuMessages.registration]: "Registration",
  [MenuMessages.operation]: "Operation",
  [MenuMessages.equipment]: "Equipment",
  [MenuMessages.administration]: "Administration",
  [MenuMessages.documentation]: "Documentation",
  [MenuMessages.support]: "Support",
  [MenuMessages.docsManual]: "Manual & Updates",
  [MenuMessages.reportsTravel]: "Reports — Trips",
  [MenuMessages.reportsVehicle]: "Reports — Vehicles",
  [MenuMessages.reportsMonitoring]: "Reports — Monitoring",
  [MenuMessages.reportsRequested]: "Reports — Requested"
};
